/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenTabletHIcon24Regular = forwardRef('TechScreenTabletHIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7 16.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5H7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3.25A3.75 3.75 0 0 0 2.25 7v10A3.75 3.75 0 0 0 6 20.75h12A3.75 3.75 0 0 0 21.75 17V7A3.75 3.75 0 0 0 18 3.25H6ZM3.75 7A2.25 2.25 0 0 1 6 4.75h12A2.25 2.25 0 0 1 20.25 7v10A2.25 2.25 0 0 1 18 19.25H6A2.25 2.25 0 0 1 3.75 17V7Z" })));
});
